import React from 'react';
import { SETUP_DATABASE_URL_PATH } from './paths';

const EditCredentials = React.lazy(
  () => import('@/components/credentials/EditCredentials'),
);

export default {
  path: SETUP_DATABASE_URL_PATH,
  element: <EditCredentials />,
};
